// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"11ea37e2","208":"fe9a6987","209":"b9141f0c","878":"88882e4a"}[chunkId] + ".chunk.js";
};